import styled from 'styled-components';
import rem from 'polished/lib/helpers/rem';
import toColorString from 'polished/lib/color/toColorString';

import { spacing } from '@decisiv/design-tokens';
import color from '@decisiv/design-tokens/lib/color';

import AsteriskIcon from '@decisiv/iconix/lib/components/Asterisk';

import Flex from '@decisiv/ui-components/lib/components/Flex';

export const ContentWrapper = styled(Flex)`
  flex-direction: column;
  width: 100%;
  margin-top: ${rem(spacing.base * 0.5)};
  gap: ${rem(spacing.base)};
`;

export const Asterisk = styled(AsteriskIcon).attrs({
  color: toColorString(color.status.information.medium),
  size: 'medium',
})`
  vertical-align: middle;
`;

export const AsteriskSmall = styled(AsteriskIcon).attrs({
  color: toColorString(color.status.information.medium),
  size: 'small',
})``;

export const RequiredMessage = styled(Flex)`
  flex: 1;
  gap: ${rem(spacing.base * 0.5)};
  align-items: center;
  justify-content: flex-end;
`;

export const SectionLabel = styled(Flex)`
  align-items: start;
`;

export const PhoneNumberWrapper = styled(Flex)`
  gap: ${rem(spacing.base)};
  align-items: flex-start;

  & > div:first-child {
    max-width: 110px;
  }
`;

export const AddressRowWrapper = styled(Flex)`
  gap: ${rem(spacing.base)};
  align-items: flex-start;

  & > * {
    flex: 1;
    min-width: 0;
  }
`;

export const ModalContentWrapper = styled(Flex)`
  flex: 1;
  flex-direction: column;
  gap: ${rem(spacing.base)};
  & > form {
    flex: 1;
  }
`;

export const DepotsWrapper = styled(Flex)`
  flex-direction: column;
  padding: ${rem(spacing.base * 1.5)};
  border: 1px solid ${toColorString(color.base.halfMoon)};
`;
